import { put, takeLatest } from "redux-saga/effects";
import { enrollmentActions } from "src/store/enrollment/enrollment.actions";
import { backendUrl } from "src/config";
import qs from "qs";
import axiosInstance from "src/axios-instance";

function* getStoredState() {
  try {
    const resp = yield axiosInstance.request({
      method: "GET",
      url: `${backendUrl}/api/temp_storage_enrollment`,
      withCredentials: true
    });
    yield put(
      enrollmentActions.fetchStoredStateSuccess({
        storedState: resp.data.temp_storage_registration
      })
    );
  } catch (e) {
    yield put(enrollmentActions.fetchStoredStateFailure());
  }
}

function* resetStoredState() {
  try {
    const resp = yield axiosInstance.request({
      method: "DELETE",
      url: `${backendUrl}/api/temp_storage_enrollment`,
      withCredentials: true
    });
    yield put(enrollmentActions.resetStoredStateSuccess());
  } catch (e) {
    yield put(enrollmentActions.resetStoredStateSuccess());
  }
}

function* saveStoredState(action) {
  try {
    const resp = yield axiosInstance.request({
      method: "POST",
      url: `${backendUrl}/api/temp_storage_enrollment`,
      data: qs.stringify({
        temp_storage_registration: JSON.stringify(
          action.payload.tempStorageState
        )
      }),
      withCredentials: true
    });
    if (action.payload.onSuccess) {
      action.payload.onSuccess();
    }
    yield put(enrollmentActions.saveStoredStateSuccess());
  } catch (e) {
    if (action.payload.onError) {
      action.payload.onError();
    }

    // yield put(enrollmentActions.saveStoredStateFailure());
  }
}

function* saveEnrolment(action) {
  try {
    let endpoint = "register_buy_sell";
    if (action.payload.kind === "slaughter") {
      endpoint = "/api/register_enrolment";
    } else if (action.payload.kind === "sell") {
      endpoint = `/api/register_buy_sell/${action.payload.enrolment.animal_category}/sell`;
    } else if (action.payload.kind === "buy") {
      endpoint = `/api/register_buy_sell/${action.payload.enrolment.animal_category}/buy`;
    }

    const resp = yield axiosInstance.request({
      method: "POST",
      timeout: 60 * 3 * 1000,
      url: `${backendUrl}${endpoint}`,
      data: action.payload.enrolment,
      withCredentials: true
    });
    if (action.payload.onSuccess) {
      action.payload.onSuccess(
        resp && resp.data ? resp.data.register_enrolment : null
      );
    }
    yield put(
      enrollmentActions.saveEnrolmentSuccess({
        enrolment: resp && resp.data ? resp.data.register_enrolment : null
      })
    );
  } catch (e) {
    console.error("error enrolment is", e);
    if (action.payload.onError) {
      action.payload.onError(
        e && e.response && e.response.status ? e.response.status : null
      );
    }
    const servicesDown =
      e.response &&
      e.response.data &&
      e.response.data.errorcodes &&
      e.response.data.errorcodes.indexOf("SERVICES_DOWN") >= 0;
    yield put(
      enrollmentActions.saveEnrolmentFailure({
        error:
          e && e.response && e.response.status === 422
            ? "INVALID_INPUT"
            : e && e.response && e.response.status === 503
            ? "TRY_AGAIN_IN_A_MINUTE"
            : servicesDown
            ? "SERVICES_DOWN"
            : null
      })
    );
  }
}

function* deleteEnrolment(action) {
  try {
    const resp = yield axiosInstance.request({
      method: "POST",
      url: `${backendUrl}/api/delete_registered_enrolment_by_date/${action.payload.kind}/${action.payload.date}`,
      withCredentials: true
    });
    yield put(enrollmentActions.deleteRegisteredEnrolmentSuccess());
    if (action.payload.onSuccess) {
      action.payload.onSuccess();
    }
  } catch (e) {
    console.error(e);
    yield put(enrollmentActions.deleteRegisteredEnrolmentFailure());
    if (action.payload.onError) {
      action.payload.onError();
    }
  }
}

function* getRegisteredEnrolmentDates() {
  try {
    const resp = yield axiosInstance.request({
      method: "GET",
      url: `${backendUrl}/api/registered_enrolment_dates`,
      withCredentials: true
    });
    yield put(
      enrollmentActions.fetchRegisteredEnrolmentDatesSuccess({
        dates: resp.data.registered_enrolment_dates
      })
    );
  } catch (e) {
    yield put(enrollmentActions.fetchRegisteredEnrolmentDatesFailure());
  }
}

function* getRegisteredEnrolment(action) {
  try {
    const resp = yield axiosInstance.request({
      method: "GET",
      url: `${backendUrl}/api/registered_enrolment_by_date/${action.payload.kind}/${action.payload.date}`,
      withCredentials: true
    });
    yield put(
      enrollmentActions.fetchRegisteredEnrolmentSuccess({
        enrolment: resp.data.registered_enrolment_by_date,
        date: action.payload.date
      })
    );
  } catch (e) {
    yield put(enrollmentActions.fetchRegisteredEnrolmentFailure());
  }
}

function* getPickupWeeks() {
  try {
    const resp = yield axiosInstance.request({
      method: "GET",
      url: `${backendUrl}/api/external/weeks`,
      withCredentials: true
    });

    yield put(
      enrollmentActions.fetchPickupWeeksSuccess({ pickupWeeks: resp.data })
    );

    /*
    yield put(
      enrollmentActions.fetchPickupWeeksSuccess({
        pickupWeeks: {
          sell: {
            cattle: {
              2020: {
                48: {
                  reason:
                    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
                  allowedCattleDeal: true,
                  allowed: false,
                },
                46: {
                  reason:
                    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
                  allowedCattleDeal: true,
                  allowed: false,
                },
                47: {
                  reason:
                    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
                  allowedCattleDeal: true,
                  allowed: false,
                },
                44: {
                  reason:
                    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
                  allowedCattleDeal: false,
                  allowed: true,
                },
                45: {
                  reason:
                    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
                  allowedCattleDeal: false,
                  allowed: true,
                },
                43: {
                  reason:
                    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
                  allowedCattleDeal: false,
                  allowed: true,
                },
              },
            },
          },
          buy: {
            cattle: {
              2020: {
                48: {
                  reason:
                    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
                  allowedCattleDeal: true,
                  allowed: false,
                },
                46: {
                  reason:
                    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
                  allowedCattleDeal: true,
                  allowed: false,
                },
                47: {
                  reason:
                    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
                  allowedCattleDeal: true,
                  allowed: false,
                },
                44: {
                  reason:
                    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
                  allowedCattleDeal: false,
                  allowed: true,
                },
                45: {
                  reason:
                    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
                  allowedCattleDeal: false,
                  allowed: true,
                },
                43: {
                  reason:
                    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
                  allowedCattleDeal: false,
                  allowed: true,
                },
              },
            },
          },
          slaughter: {
            sheep: {
              2020: {
                13: {
                  reason: 'Stengt for innmelding til slakt denne uken',
                  allowedCattleDeal: null,
                  allowed: false,
                },
                12: {
                  reason: 'Stengt for innmelding til slakt denne uken',
                  allowedCattleDeal: null,
                  allowed: false,
                },
                42: {
                  reason: 'Stengt for innmelding til slakt denne uken',
                  allowedCattleDeal: null,
                  allowed: false,
                },
              },
            },
            pigs: {
              2020: {
                13: {
                  reason: 'Stengt for innmelding til slakt denne uken',
                  allowedCattleDeal: null,
                  allowed: false,
                },
                12: {
                  reason: 'Stengt for innmelding til slakt denne uken',
                  allowedCattleDeal: null,
                  allowed: false,
                },
                42: {
                  reason: 'Stengt for innmelding til slakt denne uken',
                  allowedCattleDeal: null,
                  allowed: false,
                },
              },
            },
            cattle: {
              2020: {
                48: {
                  reason:
                    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
                  allowedCattleDeal: true,
                  allowed: false,
                },
                46: {
                  reason:
                    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
                  allowedCattleDeal: true,
                  allowed: false,
                },
                47: {
                  reason:
                    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
                  allowedCattleDeal: true,
                  allowed: false,
                },
                44: {
                  reason:
                    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
                  allowedCattleDeal: false,
                  allowed: true,
                },
                45: {
                  reason:
                    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
                  allowedCattleDeal: false,
                  allowed: true,
                },
                43: {
                  reason:
                    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
                  allowedCattleDeal: false,
                  allowed: true,
                },
              },
            },
          },
        },
      }),
    ); */
  } catch (error) {
    yield put(enrollmentActions.fetchPickupWeeksFailure());
  }
}

function* getReturnForms(action) {
  try {
    const { animalKind } = action.payload;
    const resp = yield axiosInstance.request({
      method: "GET",
      url: `${backendUrl}/api/external/return_form/${animalKind}`,
      withCredentials: true
    });

    yield put(
      enrollmentActions.fetchReturnFormsSuccess({
        animalKind,
        returnForm: resp.data
      })
    );
  } catch (error) {
    console.error(error);
    yield put(enrollmentActions.fetchReturnFormsFailure());
  }
}

export default [
  takeLatest(enrollmentActions.fetchPickupWeeks().type, getPickupWeeks),
  takeLatest(enrollmentActions.fetchReturnForms().type, getReturnForms),
  takeLatest(enrollmentActions.fetchStoredState().type, getStoredState),
  takeLatest(enrollmentActions.resetStoredState().type, resetStoredState),
  takeLatest(enrollmentActions.saveStoredState().type, saveStoredState),
  takeLatest(enrollmentActions.saveEnrolment().type, saveEnrolment),
  takeLatest(
    enrollmentActions.deleteRegisteredEnrolment().type,
    deleteEnrolment
  ),

  takeLatest(
    enrollmentActions.fetchRegisteredEnrolmentDates().type,
    getRegisteredEnrolmentDates
  ),
  takeLatest(
    enrollmentActions.fetchRegisteredEnrolment().type,
    getRegisteredEnrolment
  )
];
